import { render, staticRenderFns } from "./CheckoutItem.vue?vue&type=template&id=988cd840&"
import script from "./CheckoutItem.vue?vue&type=script&lang=js&"
export * from "./CheckoutItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports